function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3057",
  "data-name": "Path 3057",
  d: "M108.117,236.045h9.2a1.344,1.344,0,0,0,1.192,1.1h3.286a1.335,1.335,0,0,0,1.192-1.1h9.2a.732.732,0,0,0,0-1.445h-9.744a.678.678,0,0,0-.617.722v.167a.344.344,0,0,1-.054.206h-3.239a.333.333,0,0,1-.061-.206v-.167a.678.678,0,0,0-.617-.722h-9.738a.732.732,0,0,0,0,1.445Z",
  transform: "translate(-104.128 -218.451)",
  fill: "#403f50"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3058",
  "data-name": "Path 3058",
  d: "M18.55,22H44.7a2.948,2.948,0,0,0,2.943-2.943V17.519A.638.638,0,0,0,47,16.883H45.29v-15A2.049,2.049,0,0,0,43.27,0H19.892a1.951,1.951,0,0,0-1.95,1.95V16.89H16.236a.638.638,0,0,0-.636.636v1.538A2.948,2.948,0,0,0,18.55,22Zm-1.685-3.845h1.706a.638.638,0,0,0,.636-.636V1.95a.686.686,0,0,1,.685-.685H43.277a.8.8,0,0,1,.755.72V17.519a.638.638,0,0,0,.636.636h1.706v.9A1.683,1.683,0,0,1,44.7,20.735H18.55a1.683,1.683,0,0,1-1.678-1.678v-.9Z",
  transform: "translate(-15.6)",
  fill: "#403f50"
});
var SvgDesktop = function SvgDesktop(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    id: "desktop",
    width: 32.039,
    height: 22,
    viewBox: "0 0 32.039 22",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktop.68e2c0f9.svg";
export { ForwardRef as ReactComponent };